import { useContext, useEffect, useState } from 'react'
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { getBeatsApi, getVouchersCustomerLedgerApi, getCustomersApi } from '../api/api.js'
import { showMessage } from '../context/MessageContext.jsx';
import { AuthContext } from '../context/AuthContext.jsx'
import { useOrganizationSettings } from '../context/OrganizationSettingsContext';
import { useCompany } from '../context/CompanyContext.jsx';
import Pagination from '../components/ui/Pagination.jsx'
import { usePagination } from '../hooks/usePagination.js'

export default function CustomerLedger() {
  const [limit] = useState(30); // Items per page
  const [total, setTotal] = useState(0);
  const {user } = useContext(AuthContext)
  const { settings } = useOrganizationSettings();
  const { companyId } = useCompany();
  const pagination = usePagination(total, limit);

  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedCustomerLabel, setSelectedCustomerLabel] = useState(null);

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  // Fetch all beats on mount
  useEffect(() => {
    const params = {};
    if (settings.userWise && companyId) {
      params.companyId = companyId;
    }
    getCustomersApi(params)
      .then(res => setCustomers(res.data?.data || res.data || []))
      .catch(() => setCustomers([]));
  }, [settings.userWise, companyId]);
  
  // Fetch all users on mount
  useEffect(() => {
    setLoading(true);
    const params = {
      ...(selectedCustomer ? { customerName: selectedCustomer } : {}),
      ...(settings.userWise && companyId ? { companyId: companyId } : {}),
      page: pagination.currentPage,
      limit,
    };
    getVouchersCustomerLedgerApi(params)
    .then((res) => {
      const data = res.data?.data || res.data || [];
      setRows(data.rows || data); // Adjust if your API returns { rows, total }
      setTotal(res.data.totalCount || 0);
    })
    .catch(() => {
      setRows([]);
      setTotal(0);
    })
    .finally(() => setLoading(false));
  }, [selectedCustomer, companyId, pagination.currentPage, limit, settings.userWise]);

  const handleCustomerChange = (selectedOption) => {
    if (selectedOption === null) {
      setSelectedCustomer(null);
      setSelectedCustomerLabel(null);
    } else {
      // Otherwise, extract value and label as usual
      setSelectedCustomer(selectedOption.value);
      setSelectedCustomerLabel(selectedOption.label);
    }
    pagination.resetPagination();    
  };

  // const handleDateChange = (date) => {
  //   // Check if a date is selected
  //   if (date) {
  //     // Get the UTC time by stripping the local timezone offset
  //     const utcDate = new Date(
  //       date.getTime() - date.getTimezoneOffset() * 60000
  //     );
  //     setReceiptDate(utcDate);

  //     // Now send `utcDate` to your Node.js backend
  //     // It will represent midnight UTC of the selected day
  //     // e.g., for Oct 11, it will be 2025-10-11T00:00:00.000Z
  //     console.log(utcDate.toISOString());
  //   } else {
  //     setReceiptDate(null);
  //   }
  // }

  return (
    <div className="card">
      <h2>Ledger Outstanding</h2>
      <div className="filter-container">
        <div className="d-flex flex-column flex-md-row gap-2" style={{ flex: 1 }}>
          
          {/* Customer */}
          <div className="filter-item">
            <label className="form-label small fw-500 mb-2 d-block">Customer</label>
            <Select
              options={customers.map(c => ({ value: c.customerName, label: c.customerName }))}
              value={selectedCustomer ? { value: selectedCustomer, label: selectedCustomer } : null}
              onChange={handleCustomerChange}
              placeholder="Select Customer"
              isClearable={true}
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

        </div>
      </div>
      {/* <div
        className="d-flex align-items-center my-2 justify-content-between flex-wrap flex-md-nowrap"
        style={{
          width: '100%',
          gap: '0.5rem'
        }}
      >
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center" style={{ gap: '0.5rem' }}>
          <label className="d-flex align-items-center" style={{ minWidth: '180px', gap: '0.5rem' }}>
            Date:&nbsp;
            <ReactDatePicker
              selected={receiptDate}
              // onChange={date => setReceiptDate(date)}
              onChange={handleDateChange}
              className="form-control"
              dateFormat="dd-MM-yyyy"
              maxDate={new Date()} // Disable all dates after today
              placeholderText="Select a date"
              disabled={false}
              name="receiptDate"
            />
          </label>
          
        </div>
      </div> */}
      {loading ? 'Loading...' : (
        <div className="table-wrap" style={{ overflowX: 'visible', width: '100%' }}>
          <table className="table table-striped" style={{ width: '100%', minWidth: 'unset', tableLayout: 'auto' }}>
            <thead>
              <tr>
                {/* <th>S.No</th> */}
                <th style={{ width: '60%' }}>Customer</th>
                <th style={{ textAlign: 'right', width: '40%' }}>Outstanding</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="2" style={{ textAlign: 'center', padding: '2rem', color: '#546e7a' }}>
                    No records available
                  </td>
                </tr>
              ) : (
                rows.map((r, idx) => (
                  <tr key={r.id || idx}>
                    {/* <td>{idx + 1}</td> */}
                    <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{r.customerName}</td>
                    <td style={{ textAlign: 'right', wordWrap: 'break-word', whiteSpace: 'normal' }}>{r.totalRemaining}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {!loading && total > 0 && (
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
            />
          )}
        </div>
      )}
    </div>
  )
}
